import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-walk-talk',
  templateUrl: './walk-talk.component.html',
  styleUrls: ['./walk-talk.component.css']
})
export class WalkTalkComponent implements OnInit {
  galleryItems = [
    { id: 1, type: 'video', url: 'assets/projects/WalkTalk/001.mp4', title: '001.mp4' },
    { id: 2, type: 'video', url: 'assets/projects/WalkTalk/002.mp4', title: '002.mp4'},
    { id: 3, type: 'video', url: 'assets/projects/WalkTalk/003.mp4', title: '003.mp4'},
    { id: 4, type: 'video', url: 'assets/projects/WalkTalk/004.mp4', title: '004.mp4'},
    { id: 5, type: 'video', url: 'assets/projects/WalkTalk/005.mp4', title: '005.mp4'}
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
